export default __webpack_public_path__ + "static/media/App.e98ff080.png";